import iconsSpriteSource from '@rebootui/assets/icons/icons.svg?raw';

const SYMBOL_ID_RE = /<symbol\b[^>]*?\bid="([^"]+)"/g;

function parseSymbolIds(svg: string): readonly string[] {
    const seen = new Set<string>();
    const ids: string[] = [];
    let m: RegExpExecArray | null;
    const re = new RegExp(SYMBOL_ID_RE.source, 'g');
    while ((m = re.exec(svg)) !== null) {
        const id = m[1];
        if (!seen.has(id)) {
            seen.add(id);
            ids.push(id);
        }
    }
    ids.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
    );
    return ids;
}

export const ICON_NAMES = parseSymbolIds(iconsSpriteSource);
